module.exports = __webpack_public_path__ + "static/cloud-545f80ebed4cfe1773f3b6dfcec29155.png";